module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-client-action-buttons"
  }, [_c('div', {
    staticClass: "dropdown-buttons"
  }, [_c('EditParkingGroup', {
    attrs: {
      "item": _vm.item
    }
  }), _c('DeleteParkingGroup', {
    attrs: {
      "item": _vm.item
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-623bffae!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/ParkingGroupButtons.vue
// module id = 2544
// module chunks = 1